import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Nav } from './TabNavigation.style';
var TabNavigation = function TabNavigation(param) {
    var items = param.items;
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsx(Nav, {
            children: items.map(function(item, index) {
                if (item.isHidden) return null;
                return /*#__PURE__*/ _jsx("li", {
                    children: /*#__PURE__*/ _jsx(NavLink, {
                        to: item.path,
                        children: item.label
                    })
                }, index);
            })
        })
    });
};
export default TabNavigation;
